<div class="modal fade show" tabindex="-1" role="dialog" style="display: block;" aria-modal="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="historicoBoletoModalLabel">
          Histórico de Boleto
        </h5>
        <button type="button" class="close" aria-label="Close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div *ngIf="history">
          <div class="form-group">
            <label for="documento" class="col-form-label">Documento:</label>
            <input type="text" class="form-control" id="documento" [(ngModel)]="documento" disabled />
          </div>

          <!-- Exibindo o histórico -->
          <div class="form-group">
            <label for="history" class="col-form-label">Histórico:</label>
            <ul id="history" class="list-group">
              <li *ngFor="let item of formatarHistorico(history)" class="list-group-item">
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
        <div *ngIf="!history">
          <p>Nenhum histórico disponível.</p>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">Fechar</button>
      </div>
    </div>
  </div>
</div>
